import React, { Component } from 'react';
import 'theme-builder/dist/index.css';
import TimelessThemeStore from '../flux/TimelessThemeStore';
import TimelessThemeStoreActions from '../flux/TimelessThemeStoreActions';
import PageHeader from '../components/PageHeader';
import ThemeViewer from '../components/ThemeViewer';
import __ from '../utils/translator';
import ThemeStatusTypes from '../flux/ThemeStatusTypes';
import ThemeExerciseCompleted from '../components/ThemeExerciseCompleted';
import ThemeMarkAsCompleted from '../components/ThemeMarkAsCompleted';
import PageLoadingOverlayStore from '../flux/PageLoadingOverlayStore';
import getSearchQueryFromQueryString
  from '../utils/getSearchQueryFromQueryString';
import ThemeLabelContainer
  from '../components/theme-card/ThemeLabelContainer';
import PageTitle from '../components/PageTitle';
import Header from '../components/organisms/Header';
import ThemeStoreActions from "../flux/ThemeStoreActions";
import GlossaryStoreActions from "../flux/GlossaryStoreActions";
import themeResponsiveProperty from "../components/responsive/themeResponsiveProperty";
import {withTheme} from "styled-components";

function isTheSameThemeUrl(prevProps, props) {
  return (
    prevProps.match.params.collectionId === props.match.params.collectionId &&
    prevProps.match.params.themeId === props.match.params.themeId
  )
}

const defaultThemeProps = {
  theme: null,
  categoryId: null,
  categoryName: '-',
  themeName: '-',
  themeCover: null,
  chapters: [],
  contents: [],
  glossary: [],
  themeCompleted: false,
  nextTheme: null,
};

function mapThemeProps(theme) {
  if (theme === null) {
    return defaultThemeProps;
  }

  return {
    theme,
    categoryId: theme.categoryId,
    categoryName: theme.categoryName,
    themeName: theme.name,
    themeCover: theme.cover,
    themeConfidential: theme.confidential,
    chapters: theme.chapters,
    contents: theme.contents,
    glossary: theme.glossary,
    themeCompleted: theme.status === ThemeStatusTypes.THEME_STATUS_COMPLETED,
    nextTheme: theme.nextTheme,
  };
}

class TimelessTheme extends Component {
  state = {
    isPageLoading: PageLoadingOverlayStore.getState(),
    themeDidLoad: false,
    ...defaultThemeProps,
  };

  subscriptions = [];
  markAsCompletedTimeoutId = null;

  componentDidMount() {
    const { categoryId, themeId } = this.props.match.params;

    TimelessThemeStoreActions.find(categoryId, themeId);

    this.subscriptions.push(
      TimelessThemeStore.addListener(this.handleTimelessThemeStoreChange)
    );

    this.subscriptions.push(PageLoadingOverlayStore.addListener(() => {
      this.setState({ isPageLoading: PageLoadingOverlayStore.getState() });
    }));
  }

  componentDidUpdate(prevProps) {
    if ( ! isTheSameThemeUrl(prevProps, this.props)) {
      TimelessThemeStoreActions.find(
        this.props.match.params.categoryId, this.props.match.params.themeId,
      );
    }
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
    clearTimeout(this.markAsCompletedTimeoutId);
  }

  handleTimelessThemeStoreChange = () => {
    const theme = TimelessThemeStore.getState();

    this.setState({
      themeDidLoad: theme !== null,
      ...mapThemeProps(theme),
    });
  };

  onMarkAsCompleted = () => {
    this.setState({ themeCompleted: true });

    TimelessThemeStoreActions.complete(
      this.state.categoryId,
      this.state.theme.id
    );
  };

  onChapterEnter = (index) => {
    if (this.state.chapters[index - 1] !== undefined) {
      ThemeStoreActions.chapterEnter(this.state.chapters[index - 1]._id, this.state.theme.id);
    }
  }

  onGlossaryTermShow = glossaryId => {
    GlossaryStoreActions.viewGlossaryTerm(glossaryId);
  }

  render() {
    return (
      <div>
        <Header actions={themeResponsiveProperty(['back', 'search', 'glossary', 'profile'], undefined)(this.props)}/>

        {this.state.themeDidLoad && (
          <PageTitle withTracking title={`Timeless / ${this.state.categoryName} / ${this.state.themeName}`} />
        )}

        <PageHeader
          style={{ position: 'relative' }}
          cover={this.state.themeCover}
          crumbs={[__('Home'), __('Timeless'), this.state.categoryName, this.state.themeName]}
          title={this.state.themeName}>
          {this.state.theme !== null && (
            <ThemeLabelContainer theme={this.state.theme} />
          )}
        </PageHeader>

        { ! this.state.isPageLoading && (
          <ThemeViewer
            name={this.state.categoryName + " - " + this.state.themeName}
            highlightWord={getSearchQueryFromQueryString(this.props.location.search)}
            chapters={this.state.chapters}
            contents={this.state.contents}
            glossary={this.state.glossary}
            onChapterEnter={this.onChapterEnter}
            onGlossaryTermShow={this.onGlossaryTermShow}
          />
        )}

        {this.state.themeCompleted && (
          <ThemeExerciseCompleted
            theme={this.state.theme}
            nextTheme={this.state.nextTheme}
            exploreLink={`/timeless/${this.state.categoryId}`}
            exploreCallToAction={__("Find out all the category themes")} />
        )}

        {this.state.theme !== null && this.state.themeCompleted === false && (
          <ThemeMarkAsCompleted onClick={this.onMarkAsCompleted} />
        )}
      </div>
    );
  }
}

export default withTheme(TimelessTheme);
